import React from "react";
import "./search.css";

interface SearchProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onFilterClick?: () => void;
  showFilter?: boolean;
}

export const Search: React.FC<SearchProps> = ({
  placeholder = "Search...",
  value,
  onChange,
  onFilterClick,
  showFilter = true,
}) => {
  return (
    <div className="shared-search-row">
      <div className="shared-search-wrap">
        <svg
          className="shared-search-icon"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6844 16.6839L13.2283 13.2278M15.0954 8.73887C15.0954 12.2492 12.2497 15.0949 8.73936 15.0949C5.229 15.0949 2.3833 12.2492 2.3833 8.73887C2.3833 5.22851 5.229 2.38281 8.73936 2.38281C12.2497 2.38281 15.0954 5.22851 15.0954 8.73887Z"
            stroke="#999999"
            stroke-width="1.58901"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <input
          type="text"
          className="shared-search-input"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      {showFilter && (
        <button className="shared-filter-btn" onClick={onFilterClick}>
          <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.17942 5.56392H12.7135M0.795898 0.796875H15.097M5.56294 10.331H10.33"
              stroke="#333333"
              stroke-width="1.59219"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Filter
        </button>
      )}
    </div>
  );
};
